export enum AnnotationSubType {
	FILEATTACHMENT = "FileAttachment",
	STAMP = "Stamp",
	POLYGON = "Polygon",
	POLYLINE = "PolyLine",
	FREETEXT = "FreeText",
	SQUARE = "Square",
	CIRCLE = "Circle",
	STRIKEOUT = "StrikeOut",
	UNDERLINE = "Underline",
	SQUIGGLY = "Squiggly",
	HIGHLIGHT = "Highlight",
	TEXT = "Text",
	LINE = "Line",
	INK = "Ink",
	REDACT = "Redact",
	CARET = "Caret",
	SOUND = "Sound",
	WIDGET = "Widget",
	REPLY = "Reply",
	LINK = "Link"
}